import React, { Component } from 'react';
import { ErrorMessage, Field, FieldProps, Formik } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import { Button, Form, Grid, Header, Image, Message, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import i18n from 'i18next';

import { appStateServerRequests } from '../redux/selectors';
import { resetServerRequestAction, signInAction } from '../redux/actions';
import { SignInValues } from '../interfaces';
import { ActionType, RootState, ServerRequestStatus } from '../redux/types';

import { TranslationComponent } from '../components/TranslationComponent';
import { withTranslation } from 'react-i18next';
import { push } from 'connected-react-router';
import { Redirect } from 'react-router';
import alstomSignInLogo from '../assets/images/alstom-signin-logo.png';

const SignInSchema = (t: typeof i18n.t) =>
  Yup.object().shape({
    email: Yup.string().email(t('Invalid e-mail address')).required(t('Required field')),
    password: Yup.string().required(t('Required field')),
  });

interface SignInSceneProps extends Component {
  i18n: typeof i18n;
  t: typeof i18n.t;
  serverRequest?: ServerRequestStatus;
  signInAction: typeof signInAction;
  resetServerRequestAction: typeof resetServerRequestAction;
  push: typeof push;
}

class PSignInScene extends Component<SignInSceneProps> {
  handleSubmit = (values: SignInValues) => {
    this.props.signInAction(values);
  };

  componentWillUnmount() {
    this.props.resetServerRequestAction(ActionType.SIGN_IN);
  }

  render() {
    const { serverRequest, t } = this.props;
    return (
      <Grid textAlign="center" style={{ height: '100vh' }} verticalAlign="middle">
        <Grid.Column style={{ maxWidth: 450 }}>
          <Image src={alstomSignInLogo} size="big" />

          <Header as="h2" style={{ color: '#062173' }} textAlign="center">
            <TranslationComponent stringKey={'Log-in to your account'} />
          </Header>
          <Formik
            initialValues={{
              email: '',
              password: '',
            }}
            validationSchema={SignInSchema(t)}
            onSubmit={this.handleSubmit}
          >
            {({ handleSubmit, isSubmitting }) => (
              <Form
                size="large"
                error
                loading={isSubmitting && serverRequest && serverRequest.pending}
                onSubmit={handleSubmit}
              >
                <Segment stacked>
                  <Field name="email">
                    {({ field }: FieldProps) => (
                      <Form.Input placeholder={t('E-mail address')} fluid icon="user" iconPosition="left" {...field} />
                    )}
                  </Field>
                  <ErrorMessage name="email">{(msg) => <Message error content={msg} />}</ErrorMessage>
                  <Field name="password">
                    {({ field }: FieldProps) => (
                      <Form.Input
                        fluid
                        icon="lock"
                        iconPosition="left"
                        placeholder={t('Password')}
                        type="password"
                        {...field}
                      />
                    )}
                  </Field>
                  <ErrorMessage name="password">{(msg) => <Message error content={msg} />}</ErrorMessage>
                  <Button primary fluid size="large" type="submit">
                    <TranslationComponent stringKey={'Login'} />
                  </Button>
                  {serverRequest && serverRequest.success && (
                    <React.Fragment>
                      <Message content={t('LOGIN SUCCESS')} />
                      <Redirect to={{ pathname: '/projects' }} />
                    </React.Fragment>
                  )}
                  {serverRequest && serverRequest.error && <Message error content={serverRequest.error} />}
                </Segment>
              </Form>
            )}
          </Formik>
          <Message>
            <Link to="/reset-password">
              <TranslationComponent stringKey={'Password dimenticata'} />
            </Link>
          </Message>
        </Grid.Column>
      </Grid>
    );
  }
}

const mapStateToProps = (state: RootState) => ({ serverRequest: appStateServerRequests(state, ActionType.SIGN_IN) });

export const SignInScene = connect(mapStateToProps, { signInAction, resetServerRequestAction, push })(
  withTranslation()(PSignInScene)
);
